module.exports = __webpack_public_path__ + "img/27.63b733d9.jpg";